import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";

import { PLAN_DETAILS } from "../utils/constants";

export const selectorPlanTypeDetails = (
  planType: Exclude<
    planEnrollmentApiSpec.PlanEnrollment["planType"],
    "MeridioHealth"
  >
) => {
  return PLAN_DETAILS[planType];
};
